import SToggle from './s-toggle'

export default SToggle
